var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('brand-top-banner'),_c('mission-panel',{attrs:{"customStyle":_vm.missionCustomStyle}}),_c('honor-panel'),_c('about-panel')],1)}
var staticRenderFns = []

export { render, staticRenderFns }